import React, {useState} from 'react';
import { CurrencyDollarIcon } from '@heroicons/react/solid'
import { create_unsigned_app_call, create_unsigned_pymnt_txn, create_signed_txn_group, send_txn } from '../../../Functions/operations';
import { useAppSelector } from '../../../hooks';
import { useAppDispatch } from '../../../hooks';
import { updateDepositStepPassedNR } from '../../../reducer';

const app_id = 53291468;

export default function PayDeposit() {
  const address = useAppSelector((state) => state.subscription.optedInNRAddress);
  const dispatch = useAppDispatch();

  const [ confirmed, setConfirmed ] = useState(false)
  const [ error, setError ] = useState({error: false, message: ''})

  // function unpack(str: string) {
  //   const bytes = [];
  //   for(let i = 0; i < str.length; i++) {
  //     const char = str.charCodeAt(i);
  //     bytes.push(char >>> 8);
  //     bytes.push(char & 0xFF);
  //   }
  //   return bytes;
  // }

  const handlePayment = async () => {
    try {
      //build payment txn
      const unsigned_pymnt_txn = await create_unsigned_pymnt_txn(address, app_id, undefined);
      const unsigned_app_call = await create_unsigned_app_call(address, [], app_id)
      const signed_txn_group = await create_signed_txn_group([unsigned_pymnt_txn, unsigned_app_call]);
      const txn_id = await send_txn(signed_txn_group);
      console.log(txn_id);

      dispatch(updateDepositStepPassedNR(true));
      setError({error:false, message: ''})
      setConfirmed(true);
    } catch (error) {
      console.error('HANDLE PAYMENT ERROR:::', error);
      setError({error: true, message: 'An error has occured. Try again later, or contact info@goracle.io'})
    }
  }

  return (
    <div style={{minHeight: '35em'}}>
      <div className="container w-full mx-auto overflow-hidden">
        <p className="mt-5 text-lg  max-w-3xl text-gray-900">
          Ensure you have read the Goracle documentation on how to run nodes.
        </p>
        <button
          onClick={handlePayment}
          type="button"
          className=" my-10 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
            Pay Deposit
          <CurrencyDollarIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

